module.exports = __webpack_public_path__ + "static/media/data.03bec717.svg";